// extracted by mini-css-extract-plugin
export default {"ty-body":"thankyou_ty-body__Kilwk","fixed-header":"thankyou_fixed-header__vfKDr","btn":"thankyou_btn__KSPbA"};